// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
  position: fixed;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0s ease-in-out;
  z-index: 9999;
}

.notification.visible {
  opacity: 1;
}

.success {
  background-color: #4caf50;
  color: #fff;
}

.error {
  background-color: #f44336;
  color: #fff;
}

.notification.top-left {
  top: 1rem;
  left: 1rem;
}

.notification.top-right {
  top: 1rem;
  right: 1rem;
}

.notification.bottom-left {
  bottom: 1rem;
  left: 1rem;
}

.notification.bottom-right {
  bottom: 1rem;
  right: 1rem;
}
`, "",{"version":3,"sources":["webpack://./app/components/Notifications/Toasts.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".notification {\n  position: fixed;\n  padding: 1rem;\n  border-radius: 4px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n  transition: opacity 0s ease-in-out;\n  z-index: 9999;\n}\n\n.notification.visible {\n  opacity: 1;\n}\n\n.success {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.error {\n  background-color: #f44336;\n  color: #fff;\n}\n\n.notification.top-left {\n  top: 1rem;\n  left: 1rem;\n}\n\n.notification.top-right {\n  top: 1rem;\n  right: 1rem;\n}\n\n.notification.bottom-left {\n  bottom: 1rem;\n  left: 1rem;\n}\n\n.notification.bottom-right {\n  bottom: 1rem;\n  right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
